$(document).on('scroll', function(e){
	let scrollTop = $(this).scrollTop(),
		header = $('.header');
	
	(scrollTop >= 10) ? header.addClass('is-fixed') : header.removeClass('is-fixed');
});
